import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";


// Eagerly import every locale JSON at build time.
// Vite resolves this to a static map — no runtime fetching.
const localeModules = import.meta.glob<{ default: Record<string, unknown> }>(
  "./locales/*.json",
  { eager: true }
);

const resources: Record<string, { translation: Record<string, unknown> }> = {
  en: { translation: en as Record<string, unknown> },
};

for (const [path, mod] of Object.entries(localeModules)) {
  const code = path.replace("./locales/", "").replace(".json", "");
  // English is authoritative; a stale duplicate locale must not replace it.
  if (code !== "en") resources[code] = { translation: mod.default };
}

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: "en",
      fallbackLng: "en",
      supportedLngs: Object.keys(resources),
      nonExplicitSupportedLngs: true,
      interpolation: { escapeValue: false },

      react: { useSuspense: false },
    });
}

// Refresh resource contents on module updates as well as initial startup;
// the long-lived SSR i18next instance otherwise keeps pre-update copy.
for (const [code, resource] of Object.entries(resources)) {
  i18n.addResourceBundle(code, "translation", resource.translation, false, true);
}

export default i18n;